export default "__VITE_ASSET__nqXpa72Q__"